import * as React from 'react';
import { translate } from 'react-i18next';
import Campaign from 'common/modules/campaign/domain/Campaign';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';
import Permissions from 'statsradio/modules/authorisation/Permissions';
import AuthorisedComponent from 'statsradio/modules/authorisation/AuthorisedComponent';

type Props = {
  campaign: Campaign;
  onClick: () => void;
  t: (key: string) => string;
}

const CampaignLinkingButton = ({ campaign, onClick, t }: Props) => {
  return (
    <AuthorisedComponent permissions={Permissions.LINK_EXTERNAL_CAMPAIGNS}>
      <RaisedButton
        primary
        label={t('linking')}
        onClick={onClick}
      />
    </AuthorisedComponent>
  );
};

export default translate('campaigns')(CampaignLinkingButton);



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/components/CampaignLinkingButton.js